/**
 * デバウンス関数（React用）
 *
 * 連続して呼び出される関数の実行を遅延させ、最後の呼び出しのみを実行する
 * スライダー操作などの高頻度イベントのパフォーマンス最適化に使用
 *
 * @example
 * const debouncedSearch = debounce(searchFunction, 300);
 * debouncedSearch('query'); // 300ms後に実行
 * debouncedSearch.cancel(); // キャンセル
 */
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): T & { cancel: () => void } {
  let timeoutId: NodeJS.Timeout | null = null;

  const debounced = function(this: any, ...args: Parameters<T>) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  } as T & { cancel: () => void };

  debounced.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  return debounced;
}
